var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-head"},[_c('img',{attrs:{"src":require("../assets/img/homeLogo.png"),"alt":""}}),_c('div',{staticClass:"right",on:{"click":_vm.setLange}},[_c('img',{attrs:{"src":require("../assets/img/qiub.png"),"alt":""}}),_vm._v(_vm._s(_vm.$store.state.languageName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }